import React, { useEffect, useState } from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { DatePicker } from 'components/DatePicker/DatePicker';

import { useEditShopRequestModalContext } from './EditShopRequestModalContext';
import ShopRequestsRepeatPicker from '../ShopRequestsRepeatPicker';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 20px 20px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: solid 1px var(--line-gray);
`;

const Title = styled(Typography.Text)`
  font-family: var(--font-bold);
  margin-bottom: 10px;
`;

const Column = styled.div`
  display: flex;
  flex-flow: column;
`;

const EditShopRequestModalDates = () => {
  const { shopRequest, setShopRequest } = useEditShopRequestModalContext();
  const [repeatEnabled, setRepeatEnabled] = useState(false);

  useEffect(() => {
    if (shopRequest) {
      setRepeatEnabled(Boolean(shopRequest.endRepeat));
    }
  }, []);

  const changeDate = (date: Date) => {
    if (shopRequest) {
      setShopRequest({ ...shopRequest, dueDate: date });
    }
  };
  const changeRepeat = (value: number) => {
    if (shopRequest) {
      setShopRequest({ ...shopRequest, repeat: value });
    }
  };
  const changeEndRepeat = (value: number) => {
    if (shopRequest) {
      setShopRequest({ ...shopRequest, endRepeat: value });
    }
  };

  return (
    <Container>
      <Column>
        <Title>Due date</Title>
        <DatePicker selectedDate={shopRequest!.dueDate} onChange={changeDate} dataTestId="sr-modal-due-date" />
      </Column>
      <ShopRequestsRepeatPicker
        repeat={shopRequest?.repeat || 1}
        endRepeat={shopRequest?.endRepeat || 1}
        repeatEnabled={repeatEnabled}
        setRepeat={changeRepeat}
        setEndRepeat={changeEndRepeat}
        setRepeatEnabled={setRepeatEnabled}
      />
    </Container>
  );
};

export default EditShopRequestModalDates;
